/*
 * @Descripttion: 
 * @version: 
 * @Author: dingzhaowei
 * @Date: 2024-04-07 13:47:18
 * @LastEditors: dingzhaowei
 * @LastEditTime: 2024-04-09 16:21:55
 * @FilePath: \mobile-portal\src\global\getToken.js
 */
import { axios } from '../global';

export function requestToken( userName ) {
  return axios({
    url: 'WeChatLnterfaceBusiness/GetMobileToken?UserName='+`${userName}`,
    method: 'get',
    headers: {
      // Authorization: 'Basic Y3Foeno6d2hkc3Vuc29mdDgwMw==',
    },
    data: {
      'UserName':userName,
    },
  });
}

export function updateToken(refreshToken) {
  const headers = { 'Content-Type': 'application/json;charset=utf-8',
    Authorization: 'Basic Y3Foeno6d2hkc3Vuc29mdDgwMw==' };
  const formData = new FormData();
  formData.append('grant_type', 'refresh_token');
  formData.append('refresh_token', `${refreshToken}`);
  return axios({
    url: 'paicoreuaa/oauth/token',
    method: 'post',
    headers,
    data: formData,
  });
}

/**
 * @FunctionName: 获取 当前登录人的 待办数量
 * @param { ConfigType } 
 * @return {*} ConfigType
 * @Author: dingzhaowei
 * @Date: 2023-09-27 17:26:12
 * @Description: 
 */
export function getdDailyWorkNum(data) {
  return axios({
    'url': 'WeChatLnterfaceBusiness/GetPendingFlowCount',
    'method': 'POST',
    'data': data
  });
}
/**
 * @FunctionName: 获取 当前登录人的 已办数量
 * @param { ConfigType } 
 * @return {*} ConfigType
 * @Author: dingzhaowei
 * @Date: 2023-09-27 17:26:12
 * @Description: 
 */
export function getdDailyWorkNumDone(data) {
  return axios({
    'url': 'WeChatLnterfaceBusiness/GetCompletedFlowCount',
    'method': 'POST',
    'data': data
  });
}